import { Directive } from '@angular/core';
/**
 * @ngdoc directive
 * @name ApTabLabelDirective
 * @module ApTabModule
 * @description Used for marking ng-layout as a custom tab label
 */
@Directive({ selector: '[apTabLabel]' })
export class ApTabLabelDirective {}
